// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.row[data-v-a03af552] .multiselect__single {\n\tz-index: auto !important;\n}\n", ""]);
// Exports
module.exports = exports;
